<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_welcome_sign_up_welcome }} {{ userDetails.username }}!</h1>
          <img :src="getTranslations.project_config_modal_img" alt="">
        </div>
        <div class="modal__body welcone_pad">
          {{ getTranslations.home_modals_welcome_sign_up_proof_your_knowledge }}
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'welcome-signup',
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeSignup.vue